module.exports = __webpack_public_path__ + "img/character_sp.827a51ea.jpg";